module.exports = __webpack_public_path__ + "media/images/city/008-al-shaheed-monument-1f055d94173719435807400ea11c4ed7.svg";